<template>
  <div class="vip_footer">
    <div class="box">
      <div class="bg"></div>
      <div class="footer_info">
        <div class="logo_box">
          <img src="../../../static/img/home/dc_logo.png">
          <img src="../../../static/img/home/dragon_logo.png">
        </div>
        <div class="seg_line"></div>
        <div class="info_box">
          <div>
            <p>
              <a href="http://www.miitbeian.gov.cn/" target="_blank"><span>闽ICP备13010990号-3</span></a>
              <a href="/static/img/home/icp.pdf" target="_blank"><span>ICP证：闽B2-20160006</span></a>
              <a>法律顾问：福建思中律师事务所</a>
            </p>
            <p>
              <a>厦门点触科技股份有限公司 © 2014-2018</a>
              <a>股票代码：870702 </a>
            </p>
            <p>
              <a href="/static/img/home/wen.jpg" target="_blank">
                <span>闽网文[2015]1664-031号</span>
                <img src="../../../static/img/home/wen_logo.png" class="wen_icon">
              </a>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302001590"
                 target="_blank">
                <span>闽公网安备35020302001590号</span>
                <img src="../../../static/img/home/public_icon.png" class="public_icon">
              </a>
              <a href="http://wljg.xmgs.gov.cn:8080/ei/Ei!certificate.action?id=40288a855842558201586abbd0f30096"
                 target="_blank">
                <img src="../../../static/img/home/rz_logo.png" class="business_icon">
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
  .vip_footer{
    width: 100%;
    min-width: 1188px;
    height: 236px;
    background: #2f2f2f;
    clear: both;
    .box{
      position: relative;
      width: 100%;
      height: 100%;
    }
    .bg{
      position: absolute;
      left: 57px;
      top:0;
      width: 936px;
      height: 236px;
      background: url("../../../static/img/home/footer_bg.jpg") no-repeat;
    }
    .footer_info{
      height: 122px;
      padding-top: 58px;
      margin: 0 auto;
      display: table;
      z-index: 10;
      .logo_box{
        float: left;
        position: relative;
        width: 365px;
        height: 120px;
        img{
          position: absolute;
          &:nth-child(1){
            width: 178px;
            height: 58px;
            left: 0;
            top:31px
          }
          &:nth-child(2){
            width: 157px;
            height: 51px;
            left: 208px;
            top:35px;
          }
        }
      }
      .seg_line{
        float: left;
        position: relative;
        z-index: 5;
        margin:0 32px;
        width: 1px;
        height: 120px;
        background: url("../../../static/img/home/footer_line.png") no-repeat;
      }
      .info_box{
        float: left;
        height: 100%;
        position: relative;
        div{
          margin-top: 8px;
          p{
            text-align: left;
            margin: 0 0 12px 0;
            a{
              text-decoration: none;
              font-size: 14px;
              color: #fff;
              border-right: 2px solid #d6d6d6;
              padding:0 8px 0 5px;
              &:nth-child(1){
                padding: 0 8px 0 0;
              }
              &:last-child{
                border-right:none;
                padding: 0 0 0 5px;
              }
              span {
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .wen_icon {
                width: 32px;
                height: 33px;
                margin: -12px 0 -10px 3px;
              }
              .public_icon {
                width: 28px;
                height: 31px;
                margin: -14px 0 -6px 3px;
              }
              .business_icon {
                margin: -30px 0 -4px 0;
                width: 108px;
                height: 45px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue